import React, { Component } from 'react'
import { connect } from 'react-redux'
import Router from 'next/router'
import { Collapse, List, Tooltip, Badge, Menu } from 'antd'
import { withTranslation } from 'react-i18next'
import withRouterParams from '../common/RouterUtils'
import * as qs from 'qs'
import {
  setShowSidePanel,
  setSelectedCatalogLine,
  setSelectedBrand,
  getBrandsBySegments,
  getProductsByLineaCatalogo,
  toggleShowBadge,
} from '../../actions'
import { hasAccess } from '../../lib/AuthUtils'
import { PERMISSIONS } from '../../constants/AuthConstants'

const Panel = Collapse.Panel

const customPanelStyle = {
  background: 'transparent',
  borderRadius: 4,
  marginBottom: 0,
  border: 0,
  overflow: 'hidden',
}

const PARAM_LINEACATALOGOID = 'lineaCatalogoId'
const PARAM_SORT = 'orden'

class CatalogCategories extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedItem: null,
    }
  }

  onClose = () => {
    this.props.setShowSidePanel(false)
  }

  goToFavorites = () => {
    this.props.toggleShowBadge()
    Router.push({ pathname: '/favorites' })
  }

  componentDidMount() {
    // Check if a segment is selected, else load User's segments.
    const segmentIds = []
    this.props.getBrandsBySegments(segmentIds)
  }

  handleLoadProducts(lineaCatalogoId, order) {
    const { isMobile } = this.props

    const params = {
      lineaCatalogoId,
      pageSize: 12,
      page: 1,
      order,
    }
    this.props.setSelectedCatalogLine(lineaCatalogoId)
    this.props.getProductsByLineaCatalogo(params)
    
    if (isMobile) { this.onClose() }
  }

  renderMenuTree(segments) {
    const { selectedSegment } = this.props
    let result

    if (selectedSegment) {
      segments.forEach((segment) => {
        if (segment.id.toString() === selectedSegment.id.toString()) {
          result = segment
        }
      })
    } else {
      result = segments
    }

    return this.renderTree(result)
  }

  renderTree(data) {
    let result

    if (Array.isArray(data)) {
      if (data.length > 1) {
        result = this.renderSegments(data)
      } else {
        result = data[0].brands ? this.renderBrands(data[0].brands) : null // If it has only one segment, the labels are displayed directly.
      }
    } else {
      result = data.brands ? this.renderBrands(data.brands) : null
    }

    return (
      <Menu mode='inline' className='categories-menu'>
        {result}
      </Menu>
    )
  }

  renderSegments(segmentos) {
    const { t, user, favoritesBadgeFlag, prodWithDiff } = this.props

    return (
      <Collapse bordered={false} accordion>
        {segmentos.map((element, index) => {
          return (
            <Panel
              header={element.descripcion.toUpperCase()}
              className='categories-header-list'
              key={index}
              style={customPanelStyle}
            >
              {element.brands && this.renderBrands(element.brands)}
            </Panel>
          )
        })}
        {hasAccess(user, [PERMISSIONS.PAGE.FAVORITE]) && (
          <div className='favorite-left-panel' onClick={this.goToFavorites}>
            <p>
              {t('FAVORITE.FAVORITES_UPPERCASE')}
              {favoritesBadgeFlag && prodWithDiff.existDifferences ? (
                <Tooltip title={t('Some of your favourite products have news')} placement='top'>
                  <Badge count={'!'} offset={[5, -3]}></Badge>
                </Tooltip>
              ) : null}
            </p>
          </div>
        )}
      </Collapse>
    )
  }

  handleBrandLevelChange(brands, index) {
    if (!index) return

    const brand = brands[index]
    if (brand && brand.lineaCatalogos && brand.lineaCatalogos.length === 1) {
      const item = brand.lineaCatalogos[0]
      this.setState({ selectedItem: item.id })
      this.updateURL({ [PARAM_LINEACATALOGOID]: item.id }, true)
      this.handleLoadProducts(item.id)
    }
  }

  renderBrands(brands) {
    return (
      <Collapse
        bordered={false}
        accordion
        onChange={(index) => {
          this.props.setSelectedBrand(brands[index])
          this.handleBrandLevelChange(brands, index)
        }
      }
      >
        {brands.map((brand, brandIndex) => {
          return (
            <Panel
              header={brand.descripcion}
              key={brandIndex}
              showArrow={brand.lineaCatalogos && brand.lineaCatalogos.length > 1}
              className={`brands-header-list ${brand.lineaCatalogos && brand.lineaCatalogos.length === 1 ? 'brands-leaf' : ''}`}
              style={customPanelStyle}
            >
              {brand.lineaCatalogos &&
                brand.lineaCatalogos.length > 1 &&
                this.renderListItem(brand)}
            </Panel>
          )
        })}
      </Collapse>
    )
  }

  renderListItem(itemList) {
    const { closeCategories } = this.props
    return (
      <List
        size='small'
        bordered={false}
        dataSource={itemList.lineaCatalogos}
        renderItem={(item) => (
          <List.Item className={item.id === this.state.selectedItem ? 'item-selected' : ''}>
            <a
              style={{ width: '100%' }}
              onClick={() => {
                this.setState({ selectedItem: item.id })
                let parsedString = {}
                const { location } = window

                if (location && location.search) {
                  parsedString = qs.parse(location.search.slice(1))
                }
                if (parsedString.orden) {
                  this.updateURL(
                    {
                      [PARAM_LINEACATALOGOID]: item.id,
                      [PARAM_SORT]: parsedString.orden,
                    },
                    true,
                  )
                  this.handleLoadProducts(item.id, parsedString.orden)
                } else {
                  this.updateURL(
                    { [PARAM_LINEACATALOGOID]: item.id },
                    true,
                  )
                  this.handleLoadProducts(item.id)
                }

                if (closeCategories) {
                  this.onClose()
                }
              }}
            >
              {item.descripcion}
            </a>
          </List.Item>
        )}
      />
    )
  }

  render() {
    const { showSidePanel, selectedSegments } = this.props

    if (showSidePanel && selectedSegments && !selectedSegments.segmentos) {
      this.props.getBrandsBySegments([])
    }

    return (
      <div>
        {selectedSegments &&
          selectedSegments.segmentos &&
          this.renderMenuTree(selectedSegments.segmentos)}
      </div>
    )
  }
}

const mapStateToProps = (globalState) => {
  return {
    showSidePanel: globalState.catalog.showSidePanel,
    selectedSegments: globalState.catalog.selectedSegments,
    categories: globalState.catalog.categories,
    selectedCatalogLine: globalState.catalog.selectedCatalogLine,
    userId: globalState.auth.userId,
    user: globalState.auth.user,
    selectedSegment: globalState.catalog.catalogSegment,
    favoritesBadgeFlag: globalState.catalog.favoritesBadgeFlag,
    prodWithDiff: globalState.catalog.productsWithDifferences,
  }
}

const mapDispatchToProps = (dispatch) => ({
  getProductsByLineaCatalogo: (params) => {
    dispatch(getProductsByLineaCatalogo(params))
  },
  setSelectedCatalogLine: (lineaCatalogoId) => {
    dispatch(setSelectedCatalogLine(lineaCatalogoId))
  },
  setSelectedBrand: (brandId) => {
    dispatch(setSelectedBrand(brandId))
  },
  setShowSidePanel: (payload) => {
    dispatch(setShowSidePanel(payload))
  },
  getBrandsBySegments: (segmentIds) => {
    dispatch(getBrandsBySegments(segmentIds))
  },
  toggleShowBadge: () => {
    dispatch(toggleShowBadge())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withTranslation()(
    withRouterParams(CatalogCategories, {
      [PARAM_LINEACATALOGOID]: PARAM_LINEACATALOGOID,
      [PARAM_SORT]: PARAM_SORT
    }),
  ),
)
